export const isEmailAvailableSelector = (store) => store.emailAvailable.isEmailAvailable;

export const isLoadingEmailAvailabilitySelector = (store) => store.emailAvailable.isLoading;
